import { Model, ModelFactory } from '@angular-extensions/model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SolicitudServicio } from '../model/solicitud-servicio';
import { Solicitud } from '../model/solicitud';
import { ResponseResSerieDocModule } from '../model/response-res-serie-doc.module';

const API_SOLICITUDES_SERVICIO = '/Services';

@Injectable()
export class SolicitudServicioService {

  private model: Model<SolicitudServicio>;

  solicitud$: Observable<SolicitudServicio>;

  dirty = false;
  solicitudActual: string;

  constructor(
    private modelFactory: ModelFactory<SolicitudServicio>,
    private http: HttpClient
  ) {
    this.model = this.modelFactory.create(undefined);
    this.solicitud$ = this.model.data$;
  }

  getSolicitudActual(): SolicitudServicio {
    return this.model.get();
  }

  actualizarSolicitudActual(tipoSolicitud: string, solicitud: SolicitudServicio) {
    this.model.set(solicitud);
    this.dirty = !!this.model.get() && !!this.model.get().unidades && this.model.get().unidades.length > 0;
  }

  comprobarRestaurarSerieDocumentalInterna(idSerie: number): Observable<ResponseResSerieDocModule> {
    const llamada = environment.API_BASE + '/Series/RestoreSerieDocumentalInterna?serieDocumental=' + idSerie;
    return this.http.get<ResponseResSerieDocModule>(llamada);
  }

  crearSolicitud(solicitud: Solicitud): Observable<number> {
    return this.http.post<number>(environment.API_BASE + API_SOLICITUDES_SERVICIO, solicitud.toView());
  }

  getRouteForExistingServiceRequest(serviceRequest: number): Observable<string> {
    return this.http.post<string>(`${environment.API_BASE}/Masivas/GetIdRoute/${serviceRequest}`, undefined);
  }

  isGestionable(idSolicitud: number): Observable<boolean> {
    return this.http.get<boolean>(`${environment.API_BASE}/Services/permisoSolicitud/${idSolicitud}`);
  }

  recoverFieldsFilter(): Observable<any> {
    return this.http.get<any>(environment.API_BASE + '/Services/GetFieldsFilterSeries');
  }

}
